'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var hooks_useUUID = require('../hooks/useUUID.js');
var FieldContext = require('./FieldContext-DI94tJqT.js');
var InternalFlexBox = require('./InternalFlexBox-BDDWEQ9L.js');
var icons_IconSuccess = require('../icons/IconSuccess.js');
var icons_IconAlert = require('../icons/IconAlert.js');
var icons_IconDanger = require('../icons/IconDanger.js');
var components_text_Text = require('../components/text/Text.js');
var utilities_combineClasses = require('./combineClasses-5P8GTQkg.js');
var components_visuallyHidden_VisuallyHidden = require('../components/visuallyHidden/VisuallyHidden.js');
var components_form_FormContext = require('../components/form/FormContext.js');

require("../_assets/BaseMessage-B9RRDEe0.css");var styles = {"baseMessage":"BaseMessage__lSqW_jx_jR__baseMessage"};

const BaseMessage = react.forwardRef(({ children, status, id, className, testId, disabled, ...props }, ref) => {
    const uuid = hooks_useUUID.useUUID({ prefix: 'message' });
    const fieldContext = FieldContext.useFieldContext();
    const addDescriptionId = fieldContext?.addDescriptionId;
    const removeDescriptionId = fieldContext?.removeDescriptionId;
    const addErrorMessageId = fieldContext?.addErrorMessageId;
    const removeErrorMessageId = fieldContext?.removeErrorMessageId;
    const { Icon, color } = status
        ? statusToIcon[status]
        : { Icon: undefined, color: undefined };
    react.useEffect(() => {
        // if the id prop is not set then we automatically register a uuid for the field context to use
        if (id === undefined) {
            const isErrorMessage = status === 'error';
            const addId = isErrorMessage ? addErrorMessageId : addDescriptionId;
            const removeId = isErrorMessage
                ? removeErrorMessageId
                : removeDescriptionId;
            addId?.(uuid);
            return () => removeId?.(uuid);
        }
    }, [
        id,
        status,
        uuid,
        addErrorMessageId,
        addDescriptionId,
        removeErrorMessageId,
        removeDescriptionId,
    ]);
    const hasMeaningfulChildren = children && children !== '';
    return (jsxRuntime.jsx(InternalFlexBox.InternalFlexBox, { ref: ref, gap: "100", id: id ?? uuid, "aria-live": 
        // let the screen reader know if the error message changes
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-errormessage
        status === 'error' ? 'polite' : undefined, "aria-atomic": status === 'error' ? true : undefined, "data-input-type": fieldContext?.inputType, "data-size": fieldContext?.size, className: utilities_combineClasses.combineClasses(className, styles.baseMessage, 
        // make sure that messages with empty children won't add extra spacing due to the parent's gap.
        // we can't do conditional render because aria-live needs the element to be in the DOM in order to work
        !hasMeaningfulChildren && components_visuallyHidden_VisuallyHidden.visuallyHiddenStyles.visuallyHidden), ...props, children: hasMeaningfulChildren && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [Icon && jsxRuntime.jsx(Icon, { "aria-hidden": true, size: "small", color: color }), status === 'error' && jsxRuntime.jsx(VisuallyHiddenInputLabel, {}), jsxRuntime.jsx(components_text_Text.Text, { color: status
                        ? statusToColor[status]
                        : disabled
                            ? 'gray-500'
                            : 'gray-700', size: "100", testId: testId, children: children })] })) }));
});
BaseMessage.displayName = 'BaseMessage';
const statusToColor = {
    success: 'success-700',
    warning: 'alert-700',
    error: 'danger-700',
};
const statusToIcon = {
    success: { Icon: icons_IconSuccess.IconSuccess, color: 'success-600' },
    warning: { Icon: icons_IconAlert.IconAlert, color: 'alert-500' },
    error: { Icon: icons_IconDanger.IconDanger, color: 'danger-600' },
};
const VisuallyHiddenInputLabel = () => {
    const formContext = components_form_FormContext.useFormContext();
    const fieldContext = FieldContext.useFieldContext();
    const labelText = (fieldContext?.labelId
        ? (document.querySelector(`#${fieldContext.labelId}`)?.textContent ?? '')
        : '').replace(/\*$/, '');
    return (jsxRuntime.jsxs(components_visuallyHidden_VisuallyHidden.VisuallyHidden, { children: [labelText, ' ', 
            /* changing a whitespace on every form submit to trigger the live section */
            (formContext?.submitCounter ?? 0) % 2 === 0 ? null : jsxRuntime.jsx("pre", { children: " " })] }));
};

const HelpMessage = react.forwardRef((props, ref) => {
    const { inputType, disabled } = FieldContext.useFieldContext() ?? {};
    const isHelpMessageDisabled = disabled &&
        (inputType === 'checkbox' ||
            inputType === 'radio' ||
            inputType === 'switch');
    return (jsxRuntime.jsx(BaseMessage, { testId: "help-message", disabled: isHelpMessageDisabled, ...props, ref: ref }));
});
HelpMessage.displayName = 'HelpMessage';

exports.BaseMessage = BaseMessage;
exports.HelpMessage = HelpMessage;
//# sourceMappingURL=HelpMessage-9IXnyzAp.js.map
